import {eteRouterLambdaUrl} from '../app.config';

export const eteRouter = async ({type, payload, tier = 'stg'}) => {
  let Authorization;

  try {
    Authorization = await window.ua?.auth?.getAccessToken();
    const etePayload = {
      type,
      payload,
    };

    const headers = {
      'Content-Type': 'application/json',
      Authorization,
    };

    const response = await fetch(eteRouterLambdaUrl[tier], {
      method: 'POST',
      headers,
      body: JSON.stringify(etePayload),
    });

    if (!response.ok) {
      throw new Error('Ete router failed to fetch the api', response);
    }

    return response.json();
  } catch (e) {
    console.log('[auth][eteRouter.js][eteRouter]', e);
  }
};
